import { PromoType } from '@hungryroot/rest/api/get_pricing_config/get';
import { type PromoValue } from './getPromoForOverlay';

export const getCyoPromo = (promos?: PromoValue[]) => {
  return promos?.find((promo) => {
    return PromoType.FREE_ITEM_FOR_LIFE === promo.type;
  });
};
